import Reveal from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Spotless Precision Guarantee",
    text: "Every visit runs on a 40-point, room-by-room checklist audited on-site before we leave. If a corner isn't perfect, we redo it — no questions, no extra charge.",
  },
  {
    n: "02",
    title: "Hospital-Grade, Family-Safe Chemistry",
    text: "We sanitize with non-toxic, eco-certified agents that are tough on germs and grease yet gentle around children, pets and elders. Clean shouldn't come with a chemical smell.",
  },
  {
    n: "03",
    title: "Siliguri's Own Trained Crew",
    text: "Background-verified local professionals, uniformed and machine-trained. We know Siliguri's homes, water, and dust — because we live here too.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="bg-white py-16 sm:py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-sapphire">The Swaclean Standard</p>
          <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Three promises behind every spotless space
          </h2>
        </Reveal>

        <div className="mt-12">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="grid gap-4 border-t border-slate-200 py-10 md:grid-cols-[120px_1fr_1.2fr] md:items-baseline md:gap-8">
                <span className="font-mono text-4xl font-semibold text-sapphire/30 sm:text-5xl">{c.n}</span>
                <h3 className="text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">{c.title}</h3>
                <p className="text-sm leading-relaxed text-slate-600 sm:text-base">{c.text}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-slate-200" />
        </div>
      </div>
    </section>
  );
}
